<article class="page-container flex flex-column">
  <section class="align-self-end">
    <dx-date-box name="report-date" [value]="reportDate!" [showClearButton]="false"
      (onValueChanged)="onDateChanged($event)" [displayFormat]="screen.labels.dateFormatFull"
      [acceptCustomValue]="false" [useMaskBehavior]="true" [openOnFieldClick]="true" type="date">
    </dx-date-box>
  </section>

  <section>
    <dx-pie-chart type="doughnut" [dataSource]="report">
      <dxi-series argumentField="doctor" valueField="finished">
        <dxo-label [visible]="true">
          <dxo-connector [visible]="true" [width]="1"></dxo-connector>
        </dxo-label>
      </dxi-series>
      <dxo-export [enabled]="true"></dxo-export>
    </dx-pie-chart>
  </section>

  <section>
    <p-table [value]="report" [loading]="loading" dataKey="doctoId" class="col-12 p-0">
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col data-id="doctor">
          <col data-id="current" [style.width.%]="15">
          <col data-id="finished" [style.width.%]="15">
          <col data-id="canceled" [style.width.%]="15">
        </colgroup>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th>Doctor</th>
          <th>En Consulta</th>
          <th>Finalizados</th>
          <th>Cancelados</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-report>
        <tr>
          <td>{{report.doctor}}</td>
          <td>{{report.current}}</td>
          <td>{{report.finished}}</td>
          <td>{{report.canceled}}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="4">
            {{screen.labels.emptyTable}}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </section>
</article>